var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1406 538L1406 566",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1406.5,
    cy: 533.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.99 533.19C1401.99 529.283 1405.29 526.117 1409.36 526.117C1409.94 526.117 1410.51 526.184 1411.06 526.308C1409.74 525.48 1408.19 525 1406.52 525C1401.81 525 1398 528.806 1398 533.5C1398 538.194 1401.81 542 1406.52 542C1408.81 542 1410.89 541.093 1412.43 539.62C1411.49 540.032 1410.45 540.263 1409.36 540.263C1405.29 540.263 1401.99 537.096 1401.99 533.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1415.4 532.6L1415.37 530.146L1413.54 531.719L1411.3 531.056L1412.11 533.337L1410.77 535.381L1413.1 535.218L1414.5 537.144L1415.13 534.763L1417.34 533.909L1415.4 532.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.d31fa32f2df9cf411e9bf23448c72a9d.svg";
export { ForwardRef as ReactComponent };